export default __webpack_public_path__ + "static/media/spaceship.e86972b1.gltf";